import debug from "@cher-ami/debug"
import { Component } from "~/libs/compose"
import { Timeline } from "@wbe/interpol"

const componentName = "Logo"
const log = debug(`front:${componentName}`)

type TStaticProps = {}

/**
 * @name Logo
 */
export default class Logo extends Component<TStaticProps> {
	static attrName = "Logo"

	public elements = {
		$svg: this.find<HTMLElement>("svg"),
		$paths: this.find<HTMLElement>("svg").querySelectorAll("path"),
		$letter: this.find<HTMLElement>("letter")
	}

	// ----------------------------------------------------------------------------- LIFECYCLE

	mounted() {
		log("> mounted")
	}

	unmounted() {}

	// ----------------------------------------------------------------------------- ANIMATION

	override playIn(delay): void {
		// Create a timeline instance
		const tl = new Timeline()
		log("playIn")
		const pathElements = Array.from(this.elements.$paths).reverse()
		pathElements.forEach((el, i) =>
			tl.add(
				{
					// @ts-ignore
					el,
					props: {
						y: [155, 0, "%"]
					},
					duration: 400,
					ease: "power3.out"
				},
				delay + 22 * i
			)
		)

		// animate letter
		tl.add(
			{
				el: this.elements.$letter,
				props: {
					y: [0, 100, "%"]
				},
				duration: 300,
				ease: "power3.in"
			},
			delay + 22 * pathElements.length + 300
		)
			// go back
			.add(
				{
					el: this.elements.$letter,
					props: {
						y: [-100, 0, "%"]
					},
					duration: 400,
					ease: "power3.out"
				},
				delay + 22 * pathElements.length + 700
			)
	}
}
